import { BrightcoveVideo } from "@blocks/BrightcoveVideo/BrightcoveVideo";
import ShareSocial, {
  type SocialVariant,
} from "@blocks/ShareSocial/ShareSocial";
import Heading, { HeadingElements } from "@elements/Typography/Heading";
import { BC_PLAYER_ID } from "@helper/getEnvVariables";
import { type LatestVideoResponse } from "@transformer/useBrightcoveResponse";

type Props = {
  playing: LatestVideoResponse;
  forwadedRef?: React.Ref<HTMLDivElement>;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  headerType?: HeadingElements;
  showTitle?: boolean;
  playerId?: string;
  showShare?: boolean;
  showDate?: boolean;
};

const socialIconList = ["whatsapp", "facebook", "x", "copylink"];

export default function VideoPlayer({
  playing,
  forwadedRef,
  onEnded,
  nextPlaylist,
  headerType = "h3",
  showTitle = true,
  playerId = BC_PLAYER_ID,
  showShare = true,
  showDate = true,
}: Props) {
  const { id, name, topStoryDate, formattedTime, description } = playing;
  return (
    <>
      <BrightcoveVideo
        videoId={id}
        forwardedRef={forwadedRef}
        onEnded={onEnded}
        nextPlaylist={nextPlaylist}
        playerId={playerId}
      />
      <div className="flex-col hidden lg:block">
        {showTitle && (
          <Heading
            Element={headerType}
            className="font-primary font-bold text-lg leading-900 text-black-300 mb-5 pt-5"
          >
            {name}
          </Heading>
        )}
        <div className="mb-[20px]">{description}</div>
        <div className="flex items-center justify-between mb-[20px]">
          {showDate && (
            <div>
              <span className="text-xxs lg:text-2sm text-gray-100">
                {topStoryDate}
              </span>
              <br />
              <span className="text-xxs lg:text-xs text-gray-150">
                {formattedTime} mins
              </span>
            </div>
          )}
          {showShare && (
            <div className="flex gap-5">
              {socialIconList.map((variant, index) => (
                <ShareSocial
                  variant={variant as SocialVariant}
                  pagePath={`/videos/` + id}
                  key={index}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
